import gql from "graphql-tag";

export default class QueryAppText {
  static getAppTextListing() {
    return gql`
      query getAppTextListing($language: String!, $filter: String!) {
        getAppTextListing(defaultLanguage: $language, filter: $filter) {
          edges {
            node {
              id
              textTranslations {
                ... on fieldcollection_Translation {
                  translationKey
                  translationValue
                }
              }
            }
          }
        }
      }
    `;
  }
}
